import * as React from "react";
import { TextBox } from "../../forms/informedv4/TextBoxV4";
import { useReferenceContextProvider } from "../../Core/ReferenceContextProvider";
import { MultiSelect } from "../../forms/informedv4/MultiSelectV4";
import { StudySessionType } from "webportalclient";
import { EmailValidator } from "../../forms/validation/EmailValidator";

export interface OverreadForm {
    SessionTypes: StudySessionType[];
    StudyContactEmail: string;
}

export const StudyOverreadForm = () => {
    const { sessionTypes } = useReferenceContextProvider();

    return (
        <>
            <div className="row">
                <div className="form-group col-md-4 col-sm-4 col-xs-12">
                    <label htmlFor="Name">Session Types</label>
                    <MultiSelect
                        id="SessionTypes"
                        name="SessionTypes"
                        field="SessionTypes"
                        labelKey="name"
                        valueKey="id"
                        multi
                        options={sessionTypes}
                    />
                </div>
                <div className="form-group col-md-4 col-sm-4 col-xs-12">
                    <label htmlFor="StudyContactEmail">Study contact email</label>
                    <TextBox
                        id="StudyContactEmail"
                        name="StudyContactEmail"
                        field="StudyContactEmail"
                        type="email"
                        validate={(value) => value === undefined || value === null ? undefined : EmailValidator(value)}
                    />
                </div>
            </div>
        </>
    );
}
